import React, { Component } from 'react'
import img4 from '../../images/spa/cover_footmassage.jpg'
import { connect } from 'react-redux'
import PropTypes from 'prop-types';
import { changePage, subMenuTitle } from '../../action/spa'

class SpaItemInfo extends Component {
    goBack = () => {
        this.props.changePage("subMenu");
    }
    render() {
        return (
            <div id="spa-item-details" class="item-details movie-widgets">
                <div class="search-back" data-target="spa-menu-list" onClick={this.goBack}>
                    <i class="fa fa-chevron-left"></i> Back</div>
                <div class="item-order">
                    <h4>{this.props.itemTitle} | $20.00</h4>
                    <div class="rs-item-info">
                        <div class="rs-item-thumbnail w-25">
                            <img src={img4} />
                        </div>
                        <div class="rs-itam-desc">
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</p>
                        </div>
                    </div>
                    <div class="item-info">
                        <div class="flex">
                            <div class="spa-date w-40" style={{ marginRight: "1rem" }}>
                                <div class="form-item">
                                    <label>Preferred date:</label>
                                    <input type="date" name="prefered date" />
                                </div>
                            </div>
                            <div class="spa-time w-40">
                                <div class="form-item">
                                    <label>Prefered time:</label>
                                    <select class="time-hour">
                                        <option value="8">08</option>
                                        <option value="9">09</option>
                                        <option value="10">10</option>
                                        <option value="11">11</option>
                                        <option value="12">12</option>
                                        <option value="13">13</option>
                                        <option value="14">14</option>
                                        <option value="15">15</option>
                                        <option value="16">16</option>
                                        <option value="17">17</option>
                                        <option value="18">18</option>
                                    </select> :
                                <select class="time-minute">
                                        <option value="0">00</option>
                                        <option value="30">30</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-controls center">
                        <a  data-target="spa-item-confirm" class="button">Send request</a> <a  class="button secondary w-25">Cancel</a>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        itemTitle: state.store.spa.itemTitle
    }
}

export default connect(
    mapStateToProps,
    {
        changePage,
        subMenuTitle
    }
)(SpaItemInfo);
